import ApiService from './api.config'
import Cookies from "js-cookie";

export function loginByEmail(login, password) {
  return ApiService.post('login', {
    securityType: 'DELAY',
    password,
    login,
    deviceId: Cookies.get('AUTH-DEVICE')
  })
}

export function resetPasswordByEmail(email) {
  return ApiService.post('resetPassword', {
    email,
  })
}

export function goToAddin(login) {
  return ApiService.get('addin/' + login)
}
